import types from "./mutation-types"

export default {
  setActive({ commit, state }, { id }) {
    for (let i = 0, l = state.menu.children.length; i < l; i++) {
      if (i === id && state.menu.children[i].isActive) {
        break
      }
      if (i === id && !state.menu.children[i].isActive) {
        commit(types.ENABLE_MENU_ACTIVE, { i })
        continue
      }
      if (state.menu.children[i].isActive) {
        commit(types.DISABLE_MENU_ACTIVE, { i })
      }
    }
  },
  unsetActive({ commit }, { id }) {
    commit(types.DISABLE_MENU_ACTIVE, { i: id })
  },
  setModules({ commit }, data) {
    commit(types.SET_MODULES, data)
  },
  setSystemModules({ commit }, data) {
    commit(types.SET_SYSTEM_MODULES, data)
  },
  setModuleTypes({ commit }, data) {
    commit(types.SET_MODULE_TYPES, data)
  },
  setOtherModuleTypes({ commit }, data) {
    commit(types.SET_OTHER_MODULE_TYPES, data)
  },
  //模块翻页
  updateMenu({ commit }, data) {
    commit(types.UPDATE_MENU, data)
  },
  //更新模块
  updateModule({ commit }, data) {
    commit(types.UPDATE_MODULE, data)
  },
  //模块翻页
  setApplication({ commit }, data) {
    commit(types.SET_APPLICATION, data)
  },
  setListPageTypes({ commit }, data) {
    commit(types.SET_LIST_PAGE_TYPES, data)
  },
  setDetailPageTypes({ commit }, data) {
    commit(types.SET_DETAIL_PAGE_TYPES, data)
  }
}
